import { z } from 'zod'
import { Model } from './architecture'

export const NightsValidation = z.object({
  value: z
    .number({ required_error: '[Nights] value is required' })
    .min(0, { message: '[Nights] value should be bigger than 0' }),
})

export class Nights extends Model {
  static create({ value }: z.infer<typeof NightsValidation>) {
    NightsValidation.parse({ value })
    return new Nights(value)
  }

  constructor(private readonly _value: number) {
    super()
  }

  toJSON() {
    return { value: this._value }
  }
}
